import { Controller } from "@hotwired/stimulus"

// Shows/hides field wrappers based on a <select>'s current value. Each field
// target lists the values it is visible for in data-toggle-fields-show-for
// (space separated); hidden fields have their inputs cleared so a stale
// value never gets submitted once the select moves away from it.
export default class extends Controller {
  static targets = ["select", "field"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasSelectTarget) return
    const value = this.selectTarget.value

    this.fieldTargets.forEach((field) => {
      const shownFor = (field.dataset.toggleFieldsShowFor || "").split(/\s+/)
      const show = shownFor.includes(value)
      field.classList.toggle("d-none", !show)
      if (!show) {
        field.querySelectorAll("input, select, textarea").forEach((el) => { el.value = "" })
      }
    })
  }
}
